import { Block, State } from "../../types";
import { normalizeValues } from "../getDefaultState";

export type ClearAllValuesAction = Readonly<{
  type: "CLEAR ALL VALUES";
}>;

export const clearAllValues = (state: State, _action: ClearAllValuesAction): State => {
  const blocks = Object.keys(state.blocks).reduce((prev, next) => {
    const block = prev[next];
    if (block.references.length < 1 && block.confidenceClass === "") {
      return prev;
    }
    const newBlock: Block = {
      ...block,
      confidenceClass: "",
      references: [],
      highlights:[]
    };
    if (prev === state.blocks) {
      return {
        ...prev,
        [next]: newBlock,
      };
    }
    prev[next] = newBlock;
    return prev;
  }, state.blocks);
  return {
    ...state,
    activeValue: "",
    blocks,
    modified: true,
    values: normalizeValues(state.taxonomy.taxonomyObject, {}),
  };
};
